<div class="arrow-icons">
  <i *ngIf="productOpen" (click)="toggleProduct()" class="material-icons right">
    keyboard_arrow_up
  </i>
  <i
    *ngIf="!productOpen"
    (click)="toggleProduct()"
    class="material-icons right"
  >
    keyboard_arrow_down
  </i>
</div>
<div class="row rfq-list-view">
  <div class="col-md-1">
    <div class="row">
      <div class="col-md-6" *ngIf="acceptance && product?.quoteStatusCode === 'OPEN'">
      <ng-container *ngIf="product?.quantity > 0 && product?.isOrderCreated == false">
        <div class="col-md-6 checked-product">
          <mat-checkbox
            [(ngModel)]="checked"
            (change)="changeCheck($event.checked)"
          ></mat-checkbox>
        </div>
      </ng-container>
      </div>

      <div class="col-md-6" *ngIf="!acceptance && product?.quoteStatusCode === 'OPEN'">
        <ng-container *ngIf="product?.quantity > 0 && product?.isOrderCreated == false">
          <div class="col-md-6 checked-product">
            <mat-checkbox
              [(ngModel)]="checked"
              (change)="changeCheck($event.checked)"
              [disabled]="product?.isOrderCreated == true"
            ></mat-checkbox>
          </div>
        </ng-container>
    </div>
      
      <div class="col-md-6 prod-itemnum">
        {{ product.itemNumber }}
      </div>
    </div>
  </div>
  <div class="col-md-4 left-window">
    <div class="vs-text-field">
      <label class="prod_top heading-label">{{ "quoteTracking.partOrModelNumber" | cxTranslate }} </label>

      <div class="bold">
        {{ product.partNumber }}
      </div>
    </div>

    <div *ngIf="productOpen" class="vs-text-field">
      <label class="prod_top heading-label">{{ "quoteTracking.partDescription" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.partDescription }}</div>

      <label class="prod_top heading-label">{{ "quoteTracking.serialNumber" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.serialNumber }}</div>

      <label class="prod_top heading-label">{{ "quoteTracking.tagNo" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.tagNumber }}</div>
    </div>
  </div>

  <div class="col-md-3">
    <div class="vs-text-field">
      <label class="heading-label"> {{ "quoteTracking.quant" | cxTranslate }} </label>
      <div class="bold">{{ product.quantity }}{{ "quoteTracking.each" | cxTranslate }} </div>
    </div>

    <div *ngIf="productOpen" class="vs-text-field">
      <label class="prod_top heading-label"
        >{{ "quoteTracking.unitPrice" | cxTranslate }}
        <a
          *ngIf="
            product?.discountValues?.length || product?.priceAdderData?.length
          "
          (click)="openViewBreakup()"
          class="arw"
          >{{ "quoteTracking.viewBreakup" | cxTranslate }}<i *ngIf="!breakUp" class="material-icons"
            >keyboard_arrow_down</i
          >
          <i *ngIf="breakUp" class="material-icons">keyboard_arrow_right</i></a
        >

        <div
          class="breakup-dropdown"
          *ngIf="breakUp"
          (clickOutside)="closeMenu($event)"
          [exclude]="'a,.arw'"
        >
          <div class="row list-price-row m-0">
            <span class="price-menu-heading bold col-6">{{ "quoteTracking.listPrice" | cxTranslate }}</span>
            <span class="price-menu-content bold col-6"
              >{{ currency }}
              {{
                product?.listPrice 
                  | currency: currency:"symbol-narrow"
              }}</span
            >
          </div>
          <div
            class="row discounts"
            *ngFor="let discounts of product?.discountValues"
          >
            <span class="price-menu-heading col-6">{{
              getDiscountName(discounts.code)
            }}</span>
            <span class="price-menu-content col-2"
              >{{ discounts.appliedValue | number: "1.0-0" }}%</span
            >
            <span class="price-menu-content col-4"
              >{{ discounts.currency }} -{{ discounts.formattedValue }}</span
            >
          </div>
          <div
            class="row discounts"
            *ngFor="let discounts of product?.priceAdderData"
          >
            <span class="price-menu-heading col-6">{{
              getDiscountName(discounts.code)
            }}</span>
            <span class="price-menu-content col-2"
              >{{ discounts.appliedValue | number: "1.0-0" }}%</span
            >
            <span class="price-menu-content col-4"
              >{{ discounts.currency }} {{ discounts.formattedValue }}</span
            >
          </div>
          <div
            class="row total-discounts"
            *ngIf="
              product?.discountValues?.length > 0 ||
              product?.priceAdderData?.length > 0
            "
          >
            <span class="price-menu-heading col-6">{{ "quoteTracking.totalAdjustment" | cxTranslate }}</span>
            <span class="price-menu-content col-6"
              >{{ currency }}
              {{
                getTotalDiscounts(
                  product?.discountValues,
                  product?.priceAdderData
                )
              }}</span
            >
          </div>
          <div class="row net-price">
            <span class="price-menu-heading bold col-6">{{ "quoteTracking.netPrice" | cxTranslate }}</span>
            <span class="price-menu-content bold col-6"
              >{{ currency }}
              {{
                product?.quoteNetPrice | currency: currency:"symbol-narrow"
              }}</span
            >
          </div>
        </div>
      </label>
      <div class="bold product-data-text">
        {{ currency }}
        {{ product.quoteNetPrice | currency: currency:"symbol-narrow"}}
      </div>

      <label class="prod_top heading-label">{{ "quoteTracking.extendedPrice" | cxTranslate }}</label>
      <div class="bold product-data-text">
        {{ currency }}
        {{ product.quoteExtendedPrice | currency: currency:"symbol-narrow" }}
      </div>
    </div>
  </div>

  <div class="col-md-4">
    <div class="item-status">
      <div>{{ "quoteTracking.status" | cxTranslate }}</div>
      <div>
        <span class="status-label" [ngClass]="product.quoteStatusCode">{{
          product.quoteStatusLabel
        }}</span>
      </div>
    </div>

    <div *ngIf="productOpen" class="mt10">
      <!-- <label class="prod_top heading-label">{{ "quoteTracking.reqShipDate" | cxTranslate }}</label>
      <div class="bold product-data-text">
        {{ product.requestedShipDate | date: "dd MMM yyyy" }}
      </div> -->
      <label class="prod_top heading-label">
        {{ "quoteTracking.deliveryTime" | cxTranslate }}
        <i
          class="material-icons info"
          matTooltipClass="vs-tooltip"
          matTooltip='{{ "quoteTracking.deliveryTimeToolTip" | cxTranslate }} {{ product.quoteLeadTime }}'
          >info</i
        >
      </label>
      <div class="bold product-data-text">
        {{ product.quoteLeadTime}}
      </div>

      <label class="prod_top heading-label">{{ "quoteTracking.csr" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.fieldCsr }}</div>

      <label class="prod_top heading-label">{{ "quoteTracking.addComments" | cxTranslate }}</label>
      <div class="bold product-data-text">{{ product.additionalComments }}</div>
    </div>
  </div>
</div>
<div class="row line-item-warning" *ngIf="product?.isOrderCreated == true">{{ "quoteTracking.lineItemWarning" | cxTranslate }}</div>
